import React, {useEffect,useState} from "react";
import { useHistory } from "react-router-dom";

const Download = () => {
  
  const [os, setOs] = useState('none');
  const history = useHistory();

  useEffect(() => {
    getOS();
    if (os !== 'none' && (os === 'Mac OS' || os === 'iOS' || os === 'Windows' || os === 'Linux')) {
      history.push("/");
    } else if (os !== 'none' && os === 'Android') {
      window.location.href = "https://play.google.com/store/apps/details?id=vikesh.dass.keepmeout";
    }
  }, [os]);

  function getOS() {
    const userAgent = window.navigator.userAgent,
      platform =
        window.navigator?.userAgentData?.platform || window.navigator.platform,
      macosPlatforms = ["macOS", "Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"];
    let os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      setOs("Mac OS");
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      setOs("iOS");
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      setOs("Windows");
    } else if (/Android/.test(userAgent)) {
      setOs("Android");
    } else if (/Linux/.test(platform)) {
      setOs("Linux");
    }

    return os;
  }

  return (
    <>
    </>
  );
};

export default Download;
